import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const inputStyle = {
    fieldset: {
        borderRadius: '0px',
        borderWidth: '1px',
        borderColor: '#728085',
        '&.MuiOutlinedInput-notchedOutline': {
            borderColor: '#728085 !important'
        }
    },
    input: {
        color: '#728085',
        '&.MuiInputBase-input::placeholder': {  // ✅ CORRECT SELECTOR
            color: '#728085',
            opacity: 1  // Ensures full opacity
        }
    }
};



export default function Login() {
    return (
        <Box sx={{ height: 'calc(100vh - 114px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box width={{ md: '560px', sm: '80%', xs: '90%' }} marginX={'auto'}>
                <Grid container spacing={4}>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="h1" fontFamily={'DanmarkURW'} className='dColor' fontSize={'2.875rem'} fontWeight={'bold'}>Welcome</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography variant="body1" className='dColor' fontSize={'1.125rem'} textAlign={'center'}>
                                    New to RINU? <Box component={Link} to="/signup" sx={{ textDecoration: 'underline', color: 'text.secondary' }}>Sign Up</Box> and receive 50 Reward Points.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Email Address' />
                                        </Box>
                                    </Grid>
                                    <Grid size={12}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Password' />
                                        </Box>
                                    </Grid>
                                    <Grid size={12}>
                                        <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary' }}>Log In</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12} justifyContent={'flex-end'} display={'flex'}>
                                <Typography variant="body1"  sx={{ textDecoration: 'underline' }} component={Link} to={'/forgotpassword'} className='dColor' textAlign={'end'} fontSize={'1.125rem'}>Forget Password!</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}